import {DossierN3, DossierT100, DossierT250} from "./base.model";
import {SvedClientType} from "./svedClientType.model";

export class SvedBVType extends SvedClientType {
  part: DossierN3 = '';
  dateFrom = false;
  dateEnd = false;
  bfOwner: DossierN3 = '';
  bfOther: DossierT100 = '';
  reason: DossierT250 = '';
}
